import { loadState } from '@/store'
import { getAuth0Header } from '@/services/tokenManager'
import { extractTenantFromToken, setTenant } from '@/plugins/tenants'
import { identifyUserInTracking } from '@/services/tracking'

export const loadUserData = async () => {
  const authHeader = await getAuth0Header()
  if (!authHeader) {
    console.warn('[driver-web-app - userDataHelper] - Undefined auth header')
    return
  }

  const tenant = extractTenantFromToken(authHeader)
  if (tenant) {
    setTenant(tenant)
  }

  if (!(await loadState())) {
    return
  }

  identifyUserInTracking()
}
